import { motion } from 'framer-motion';
import Timeline, { publications } from './pubtimeline';

export default function Publications() {
    return (
        <section id="publications" className="py-8 bg-white dark:bg-surface-dark w-full">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between mb-10">
                    <h2 className="text-3xl font-display font-bold text-gray-900 dark:text-white">Publications</h2>
                    <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                        {publications.length} peer-reviewed papers
                    </span>
                </div>

                <motion.div
                    className="bg-white/80 dark:bg-surface-dark/80 backdrop-blur-sm rounded-xl p-2 sm:p-4 md:p-8 shadow-xl border border-gray-100 dark:border-gray-700"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: 'easeOut' }}
                >
                    <Timeline />
                </motion.div>
            </div>
        </section>
    );
}